export enum CommonSettingsResponseKeys {
    TraderOrderShare = 'trader_order_share',
    NewTraderOrderShare = 'new_trader_order_share',
    OperatorOrderShare = 'operator_order_share',
    MinTrustBalance = 'min_trust_balance',
    MinTradeBalance = 'min_trade_balance',
    TeamLeadPayinCommissionRate = 'team_lead_payin_commission_rate',
    TeamLeadPayoutCommissionRate = 'team_lead_payout_commission_rate'
}

export enum CommonSettingsKeys {
    TraderOrderShare = 'traderOrderShare',
    NewTraderOrderShare = 'newTraderOrderShare',
    OperatorOrderShare = 'operatorOrderShare',
    MinTrustBalance = 'minTrustBalance',
    MinTradeBalance = 'minTradeBalance',
    TeamLeadPayinCommissionRate = 'teamLeadPayinCommissionRate',
    TeamLeadPayoutCommissionRate = 'teamLeadPayoutCommissionRate'
}

export const COMMON_SETTINGS_RESPONSE_KEYS_MAP = {
    [CommonSettingsResponseKeys.TraderOrderShare]: CommonSettingsKeys.TraderOrderShare,
    [CommonSettingsResponseKeys.NewTraderOrderShare]: CommonSettingsKeys.NewTraderOrderShare,
    [CommonSettingsResponseKeys.OperatorOrderShare]: CommonSettingsKeys.OperatorOrderShare,
    [CommonSettingsResponseKeys.MinTrustBalance]: CommonSettingsKeys.MinTrustBalance,
    [CommonSettingsResponseKeys.MinTradeBalance]: CommonSettingsKeys.MinTradeBalance,
    [CommonSettingsResponseKeys.TeamLeadPayinCommissionRate]: CommonSettingsKeys.TeamLeadPayinCommissionRate,
    [CommonSettingsResponseKeys.TeamLeadPayoutCommissionRate]: CommonSettingsKeys.TeamLeadPayoutCommissionRate
};
